//import React, { Component } from 'react';

import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
//import { UserContext } from "../store/userContext";
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";

export default function PasswordRecoveryChange() {
    const { state } = useLocation();
    let navigate = useNavigate();
    // const { reCreate } = useContext(UserContext);
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            mobile: "",
            code: "",
            password: "",
            confirmPassword: "",
        });
    useEffect(() => { 
        if (!state || !state.code) {
            navigate('/PasswordRecovery');
            return;
        }
        setForm({ ...form, mobile: state.mobile, code: state.code });
        ;

    }, []);


    const handlePosting = async (e) => {
        e.preventDefault();
        if (form.password.length == 0) {
            toast.error('کلمه عبور جدید  وارد نشده است', { theme: "colored" });
            return;
        } else if (form.confirmPassword.length == 0) {
            toast.error('تکرار کلمه عبور جدید  وارد نشده است', { theme: "colored" });
            return;
        } else if (form.confirmPassword != form.password) {
            toast.error('کلمه عبور جدید و تکرار کلمه عبور یکسان نمی باشد', { theme: "colored" });
            return;
        }
        setIsPosting(true);
        await noronServices.ChengePassWithVerifyCode({
            mobile: form.mobile,
            code: form.code,
            password: form.password,
        })
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                toast.dark('کلمه عبور شما تغییر کرد');
                navigate('/login', { state: { mobile: form.mobile } });
            })
            .catch(err => {
                setIsPosting(false);
            });
    }

    return (
        <>
            <div className="container col-xl-10 col-xxl-8 px-4 py-5">
                <div className="row align-items-center g-lg-5 py-5">

                    <div className="col-md-10 mx-auto col-lg-5">
                        <form asp-action="Login" className="p-4 p-md-5 border rounded-3 bg-light" method="post">
                            <div className="form-floating mb-3">
                                <input asp-for="password"
                                    type="password"
                                    name="password"
                                    value={form.password}
                                    onChange={e => http.handleChange(e, form, setForm)}

                                    className="form-control" placeholder="کلمه عبور جدید" autoComplete="off" />
                                <label asp-for="password">کلمه عبور جدید</label>
                                <span asp-validation-for="password" className="text-danger"></span>
                            </div>
                            <div className="form-floating mb-3">
                                <input asp-for="confirmPassword"
                                    type="password"
                                    name="confirmPassword"
                                    value={form.confirmPassword}
                                    onChange={e => http.handleChange(e, form, setForm)}

                                    className="form-control" placeholder="تکرار کلمه عبور جدید" autoComplete="off" />
                                <label asp-for="confirmPassword">تکرار کلمه عبور جدید</label>
                                <span asp-validation-for="confirmPassword" className="text-danger"></span>
                            </div>
                            <button className="w-100 btn btn-lg btn-primary"
                                onClick={handlePosting}
                                disabled={isPosting}>
                                ارسال
                                {isPosting &&
                                    <div className="spinner-border spinner-border-sm" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>}
                            </button>
                            <hr className="my-4" />
                            <Link to="/PasswordRecovery">دریافت کد</Link>
                        </form>
                    </div>
                </div>
            </div>
        </>

    );

}
